import { z } from 'zod';
import { useEnhancedForm } from '../../../components/forms/hooks/useEnhancedForm';
const formSchema = z.object({
    // eslint-disable-next-line deprecation/deprecation
    selectedOrganization: z.custom(value => {
        return value === undefined ? false : true;
    }),
});
export const useOrganizationSelectionForm = (initialOrganization) => {
    return useEnhancedForm({
        initialValues: {
            selectedOrganization: initialOrganization,
        },
        mode: 'onBlur',
        schema: formSchema,
    });
};
